import React from "react";
import { useNavigate } from "react-router-dom";
import { fireDB } from "../config";
import { deleteDoc, doc } from "firebase/firestore";
import {
  Card,
  Box,
  Typography,
  IconButton,
  CardMedia,
  CardActions,
  CardContent,
} from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
const CategoryList = ({ ...props }) => {
  let navigate = useNavigate();

  const handleDetail = (propId) => {
    navigate(`/dashboard/addcategory/${propId}`);
  };
  const handleDelete = async (docId) => {
    const delRef = doc(fireDB, "categories", docId);

    const chec = await deleteDoc(delRef);

    alert("delete");
  };
  return (
    <Card
      sx={{
        borderRadius: 5,
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardMedia
        component="img"
        alt="green iguana"
        height="190"
        image={props.image}
        sx={{ p: 1, borderRadius: 5 }}
      />
      <CardContent sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography gutterBottom variant="h5" component="div">
          {props.name}
        </Typography>
        <Typography gutterBottom variant="h5" component="div">
          {props.position}
        </Typography>
      </CardContent>
      <Box sx={{ mt: "auto" }} />{" "}
      <CardActions sx={{ display: "flex", justifyContent: "space-between" }}>
        <IconButton size="small" onClick={() => handleDetail(props.id)}>
          <Edit />
        </IconButton>
        <IconButton size="small" onClick={() => handleDelete(props.id)}>
          <Delete />
        </IconButton>
      </CardActions>
    </Card>
  );
};

export default CategoryList;
